export const A_TO_Z_SEARCH_RESULT_CONTAINER_ID = 'searchResultId';
export const A_TO_Z_ACTIVE_TAB_3 = 3;
